import classNames from "classnames";
import { isEmpty } from "lodash";
import { useRouter } from "next/router";
import { FC, useEffect } from "react";
import { useRecoilValue } from "recoil";
import Bag from "~/assets/svgs/bag.svg";
import { PATH } from "~/constants/enum";
import { CartAtom } from "~/services/cart";
import Button from "../Button";
import QuickCartMini from "../QuickCartMini";
import styles from "./CartButton.module.scss";
import useWindowDimensions from "~/hooks/useWindowDimensions";
import { isUsingLayoutV2 } from "~/utils/theme";

const CartButton: FC = () => {
  const router = useRouter();
  const cartSelector = useRecoilValue(CartAtom.cartSelector);
  const showMiniCart = cartSelector?.loading || !isEmpty(cartSelector?.items);
  const { width } = useWindowDimensions();
  const isMobile = typeof window !== "undefined" && window.innerWidth < 1024;

  const onOverlay = (type: "append" | "remove") => {
    if (width <= 1024) return;
    if (!showMiniCart || router.route === "/carts") return;

    if (type === "append") {
      document.body.classList.add("show-overlay");
    }

    if (type === "remove") {
      document.body.classList.remove("show-overlay");
    }
  };

  useEffect(() => {
    if (!showMiniCart) {
      document.body.classList.remove("show-overlay");
    }
    return () => {
      document.body.classList.remove("show-overlay");
    };
  }, [showMiniCart]);

  return (
    <div
      className={classNames(styles.cart_button)}
      onMouseOver={() => onOverlay("append")}
      onMouseLeave={() => onOverlay("remove")}
    >
      {(!isUsingLayoutV2 || isMobile) && !!cartSelector?.items?.length && (
        <div className={styles.cart_badge}>{cartSelector?.items?.length}</div>
      )}
      <a
        href={PATH.Carts}
        onClick={(e) => router.route === "/carts" && e.preventDefault()}
      >
        <Button
          prefixIcon={<Bag width={24} height={24} alt="bag" />}
          shape="square"
          type="borderless"
          // onClick={() => setCart({ ...cart, open: true })}
          aria-label="Shopping cart"
        >
          <p className="text-base uppercase font-normal text-[#212121] whitespace-nowrap !mb-0 pt-2 flex items-center">
            {isUsingLayoutV2 && (
              <span className="hidden lg:block mr-1">{`Cart (${cartSelector?.items?.length || 0})`}</span>
            )}
          </p>
        </Button>
      </a>
      {router.route !== "/carts" && showMiniCart && (
        <div
          className={classNames(
            styles.quick_cart_mini,
            "mt-2 transition-all hidden lg:block"
          )}
        >
          <QuickCartMini
            items={cartSelector?.items}
            loading={cartSelector?.loading}
            subtotal={cartSelector?.subtotal}
            total={cartSelector?.total}
            discount={cartSelector?.discount}
          />
        </div>
      )}
    </div>
  );
};

export default CartButton;
